import { eDeleteFunnelProgressModal } from '../../pages/Pipe/modals/DeleteFunnelProgressModal/DeleteFunnelProgressModal.enum.ts';
import { SyncConversationsEnum } from '../SyncConversationsProvider/SyncConversations.enum.ts';
import { tModalsContext } from './Modals.types';

export const initialState: tModalsContext = {
  addOptionsSecondLevelModalIsOpen: false,
  setAddOptionsSecondLevelModalIsOpen: () => {},
  addOptionsThirdLevelModalIsOpen: false,
  setAddOptionsThirdLevelModalIsOpen: () => {},
  addWorkspaceModelIsOpen: false,
  setAddWorkspaceModalIsOpen: () => {},
  connectionModalIsOpen: false,
  setConnectionModalIsOpen: () => {},
  disconnectionModalIsOpen: false,
  setDisconnectionModalIsOpen: () => {},
  metaConnectionModalIsOpen: false,
  setMetaConnectionModalIsOpen: () => {},
  metaConnectionModalReconnectRequested: false,
  setMetaConnectionModalReconnectRequested: () => {},
  metaPagesModalIsOpen: false,
  setMetaPagesModalIsOpen: () => {},
  whatsAppBusinessConnectionModalIsOpen: false,
  whatsAppBusinessConnectionModalSource: null,
  whatsAppBusinessConnectionModalExitDestination: null,
  whatsAppBusinessConnectionModalIsLegacyChosen: false,
  setWhatsAppBusinessConnectionModalIsOpen: () => {},
  syncConversationsStatus: SyncConversationsEnum.HIDDEN,
  setSyncConversationsStatus: () => {},
  showPastDueModal: false,
  togglePastDueModal: () => {},
  showTrialConfirmModal: false,
  toggleTrialConfirmModal: () => {},
  showNoPaidModal: false,
  toggleNoPaidModal: () => {},
  showPrevPastDueModal: false,
  togglePrevPastDueModal: () => {},
  showBankDetailsModal: false,
  toggleBankDetailsModal: () => {},
  changeServiceModalIsOpen: false,
  setChangeServiceModalIsOpen: () => {},
  addOptionsModalIsOpen: false,
  setAddOptionsModalIsOpen: () => {},
  deleteOptionModalIsOpen: false,
  setDeleteOptionModalIsOpen: () => {},
  changeFunnelModalIsOpen: false,
  setChangeFunnelModalIsOpen: () => {},
  showResendModal: false,
  setShowResendModal: () => {},
  advanceSearchModalIsOpen: false,
  setAdvanceSearchModalIsOpen: () => {},
  selectedLeadForChatModal: null,
  setSelectedLeadForChatModal: () => {},
  focusedChatEvent: null,
  setFocusedChatEvent: () => {},
  forceDisconnectionModalIsOpen: false,
  setForceDisconnectionModalIsOpen: () => {},
  openAdvanceFiltersModal: false,
  setOpenAdvanceFiltersModal: () => {},
  messageReadFilter: null,
  setMessageReadFilter: () => {},
  integrationFilter: null,
  setIntegrationFilter: () => {},
  statusFilter: undefined,
  setStatusFilter: () => {},
  tagsFilter: null,
  setTagsFilter: () => {},
  assignedUserFilters: null,
  setAssignedUserFilters: () => {},
  dateRange: [undefined, undefined],
  setDateRange: () => {},
  dateFilterType: undefined,
  setDateFilterType: () => {},
  directoryFunnelFilter: 'all',
  setDirectoryFunnelFilter: () => {},
  directoryStageFilter: 'all',
  setDirectoryStageFilter: () => {},
  directoryTagsMatch: 'any',
  setDirectoryTagsMatch: () => {},
  directoryFunnels: null,
  setDirectoryFunnels: () => {},
  directoryFilterCount: 0,
  undeliveredFilter: false,
  setUndeliveredFilter: () => {},
  activeFilterCount: 0,
  arePipeFiltersActive: false,
  resetFilters: () => {},
  integrationWhatsAppModalIsOpen: false,
  setIntegrationWhatsAppModalIsOpen: () => {},
  integrationInstagramModalIsOpen: false,
  setIntegrationInstagramModalIsOpen: () => {},
  integrationMessengerModalIsOpen: false,
  setIntegrationMessengerModalIsOpen: () => {},
  attachmentEditorModalIsOpen: false,
  setAttachmentEditorModalIsOpen: () => {},
  audioPermissionsModalIsOpen: false,
  setAudioPermissionsModalIsOpen: () => {},
  chatModalIsOpen: false,
  setChatModalIsOpen: () => {},
  maximizeModal: false,
  setMaximizeModal: () => {},
  currentFunnelStatus: [],
  setCurrentFunnelStatus: () => {},
  triggerDirectoryReload: false,
  setTriggerDirectoryReload: () => {},
  showSubscribeIntegrationsModal: false,
  setShowSubscribeIntegrationsModal: () => {},
  showSubscribeAddUsersModal: false,
  setShowSubscribeAddUsersModal: () => {},
  showSubscribeImportLeadsModal: false,
  setShowSubscribeImportLeadsModal: () => {},
  changesDataModalIsOpen: false,
  setChangesDataModalIsOpen: () => {},
  showDeleteFunnelModal: eDeleteFunnelProgressModal.HIDDEN,
  setShowDeleteFunnelModal: () => {},
  showArchiveLeadsModal: false,
  setShowArchiveLeadsModal: () => {},
  tiktokConnectionModalIsOpen: false,
  setTiktokConnectionModalIsOpen: () => {},
  tagOpsInFlight: { current: 0 },
};
